export default __webpack_public_path__ + "static/media/13d.c1dccc5e.jpg";